module.exports = __webpack_public_path__ + "img/Inaki.c227b197.jpg";